export const navigationData = [
  {
    path: '/',
    label: 'Market Scan',
    description: 'Search and compare PLC and industrial automation parts across supplier websites',
    priority: 1.0,
    changefreq: 'daily',
    keywords: ['Market Scan', 'PLC part search', 'PLC price comparison', 'industrial automation parts', 'automation suppliers']
  },
  {
    path: '/research',
    label: 'PLC Research',
    description: 'Browse technical research for PLC and industrial automation parts',
    priority: 0.7,
    changefreq: 'daily',
    keywords: ['PLC research', 'part specifications', 'industrial automation research']
  },
  {
    path: '/manufacturers',
    label: 'Manufacturers',
    description: 'Browse quality-checked industrial automation part pages by manufacturer',
    priority: 0.8,
    changefreq: 'daily',
    keywords: ['PLC manufacturers', 'automation manufacturers', 'industrial part numbers']
  },
  {
    path: '/request-a-part',
    productScope: 'marketplace',
    label: 'Request a Part',
    description: 'How to post a part request and receive offers from partnership sellers',
    priority: 0.7,
    changefreq: 'weekly',
    keywords: ['request a part', 'post request', 'wanted', 'buyer request', 'offers']
  },
  {
    path: '/resellers',
    productScope: 'marketplace',
    label: 'Partnership Program',
    description: 'Benefits, eligibility, and how to become a partnership seller with a public storefront',
    priority: 0.6,
    changefreq: 'monthly',
    keywords: ['partnership', 'partnership program', 'storefront', 'discounted fees', 'onboarding']
  },
  {
    path: '/browse',
    productScope: 'marketplace',
    label: 'Browse Parts',
    description: 'Browse and search for industrial automation parts and PLC components',
    priority: 0.9,
    changefreq: 'hourly',
    keywords: ['browse', 'search', 'PLC parts', 'industrial automation', 'components']
  },
  {
    path: '/requests',
    productScope: 'marketplace',
    label: 'Requested Parts',
    description: 'Browse parts buyers are looking for and make offers',
    priority: 0.7,
    changefreq: 'hourly',
    keywords: ['requests', 'wanted', 'offer parts', 'buyer requests']
  },
  {
    path: '/seller',
    productScope: 'marketplace',
    label: 'Sell on Control Exchange',
    description: 'Learn how to sell industrial automation parts on Control Exchange',
    priority: 0.7,
    changefreq: 'weekly',
    keywords: ['seller', 'sell parts', 'marketplace onboarding', 'list parts']
  },
  {
    path: '/become-a-seller',
    productScope: 'marketplace',
    label: 'Become a Seller',
    description: 'Step-by-step guide to becoming a seller and setting up payments',
    priority: 0.6,
    changefreq: 'monthly',
    keywords: ['become a seller', 'seller guide', 'onboarding', 'payments']
  },
  {
    path: '/mission-statement',
    label: 'Mission Statement',
    description: 'Our mission to revolutionize industrial automation parts trading',
    priority: 0.5,
    changefreq: 'yearly',
    keywords: ['mission', 'vision', 'values', 'purpose']
  },
  {
    path: '/contact',
    label: 'Contact Us',
    description: 'Get in touch with our support team',
    priority: 0.6,
    changefreq: 'monthly',
    keywords: ['contact', 'support', 'help', 'customer service']
  },
  // MCP Documentation - hidden until fully tested
  // {
  //   path: '/docs/mcp',
  //   label: 'MCP Documentation',
  //   description: 'Developer guide for using the Control Exchange MCP server with Claude and Cursor',
  //   priority: 0.5,
  //   changefreq: 'monthly',
  //   keywords: ['mcp', 'model context protocol', 'api docs', 'agent integration', 'claude', 'cursor']
  // },
  {
    path: '/returns',
    productScope: 'marketplace',
    label: 'Returns Policy',
    description: 'Learn about our returns policy and how to initiate a return',
    priority: 0.5,
    changefreq: 'monthly',
    keywords: ['returns', 'return policy', 'order issues', 'support']
  },
  {
    path: '/refunds',
    productScope: 'marketplace',
    label: 'Refund Policy',
    description: 'Understand our refund process and eligibility',
    priority: 0.4,
    changefreq: 'monthly',
    keywords: ['refunds', 'refund policy', 'payments', 'support']
  },
  {
    path: '/carriers',
    productScope: 'marketplace',
    label: 'Shipping & Carriers',
    description: 'Shipping information and trusted carrier partners',
    priority: 0.5,
    changefreq: 'weekly',
    keywords: ['shipping', 'carriers', 'delivery', 'tracking', 'EVRi', 'DPD', 'Royal Mail']
  },
  {
    path: '/terms',
    label: 'Terms of Service',
    description: 'Terms and conditions for using Control Exchange',
    priority: 0.3,
    changefreq: 'yearly',
    keywords: ['terms of service', 'terms', 'conditions', 'agreement']
  },
  {
    path: '/privacy',
    label: 'Privacy Policy',
    description: 'How we collect, use, and protect your data',
    priority: 0.3,
    changefreq: 'yearly',
    keywords: ['privacy policy', 'privacy', 'data protection', 'GDPR']
  },
  {
    path: '/sell',
    productScope: 'marketplace',
    label: 'Seller Dashboard',
    description: 'List your industrial automation parts for sale',
    priority: 0.8,
    changefreq: 'weekly',
    isPrivate: true,
    keywords: ['sell', 'list parts', 'seller', 'marketplace'],
    children: [
      {
        path: '/seller/onboarding',
        productScope: 'marketplace',
        label: 'Seller Onboarding',
        description: 'Get started as a seller on Control Exchange',
        priority: 0.6,
        changefreq: 'monthly',
        isPrivate: true,
        keywords: ['seller onboarding', 'become seller', 'registration']
      },
      {
        path: '/seller/connect-onboarding',
        productScope: 'marketplace',
        label: 'Stripe Connect Onboarding',
        description: 'Complete your Stripe Connect onboarding steps',
        priority: 0.6,
        changefreq: 'monthly',
        isPrivate: true,
        keywords: ['stripe connect', 'seller onboarding', 'payments']
      }
    ]
  },
  {
    path: '/dashboard',
    productScope: 'marketplace',
    label: 'Dashboard',
    description: 'Your account dashboard and order management',
    priority: 0.7,
    changefreq: 'daily',
    isPrivate: true,
    keywords: ['dashboard', 'account', 'orders', 'profile']
  },
  {
    path: '/messages',
    productScope: 'marketplace',
    label: 'Messages',
    description: 'View and manage your messages with sellers and buyers',
    priority: 0.6,
    changefreq: 'daily',
    isPrivate: true,
    keywords: ['messages', 'chat', 'communication', 'inbox']
  },
  {
    path: '/cart',
    productScope: 'marketplace',
    label: 'Shopping Cart',
    description: 'Review and checkout your selected items',
    priority: 0.6,
    changefreq: 'always',
    isPrivate: true,
    keywords: ['cart', 'checkout', 'shopping', 'purchase']
  },
  {
    path: '/checkout/shipping',
    productScope: 'marketplace',
    label: 'Checkout Shipping',
    description: 'Select shipping options for your order',
    priority: 0.5,
    changefreq: 'always',
    isPrivate: true,
    keywords: ['checkout', 'shipping', 'delivery options']
  },
  {
    path: '/checkout/confirm',
    productScope: 'marketplace',
    label: 'Checkout Confirmation',
    description: 'Confirm your order details before payment',
    priority: 0.5,
    changefreq: 'always',
    isPrivate: true,
    keywords: ['checkout', 'order confirmation', 'review order']
  },
  {
    path: '/checkout/success',
    productScope: 'marketplace',
    label: 'Checkout Success',
    description: 'Order confirmation and next steps after checkout',
    priority: 0.5,
    changefreq: 'always',
    isPrivate: true,
    keywords: ['checkout', 'order success', 'confirmation']
  }
];
